import React from "react";
import { colors } from "../../constants/colors";

export const AngeloEngine = () => {
  return (
    <section
      data-aos="fade-down"
      className="angelo-engine flex-column text-center"
      id="angelo-engine"
    >
      <div className="p-5 ">
        <h1 style={{ color: colors.gencBlue }}>Angelo Network Engines</h1>
        <p style={{ color: colors.gencBlack }}>
        Over 3.5 billion people have been victims of data breaches in their lifetime. The Equifax data breach in 2017 alone accounted for over 140 million Americans having their private tax information leaked. In the past, many data centers have used centralized servers to store application data, which is susceptible to data breaches and attacks. GenC Labs seeks to disrupt this old way of storing data by developing a Hybrid Blockchain solution. By decentralizing where the data is being stored, this solution ensures that your information can be split into separate chunks and blockchains to be stored across a network of nodes. That way, even if a hacker managed to gain access to one node, they would only have a piece of the pie, making it a hopeless endeavor for them.  </p>

        <p style={{ color: colors.gencBlack }}>

          The type of Blockchain technology we are using to achieve this goal is called Private Blockchain, a variation of Hyperledger Fabric. Our ‘hybrid’ practice ensures that storing and processing large files through the system (called Angelo Network Engines) will efficiently allow users to safely and securely store large amounts of data without the high costs typically associated with pure blockchain solutions. By signing up for this service, families or organizations will be able to receive a personalized unit of the Angelo Network Engine for their circle of members with a specialized team of DevOps engineers to help maintain that system. 
      </p>
      </div>
      <p>
        <iframe title="Angelo Engine" style={{ width: '100%', height: '600px' }} src="https://www.youtube.com/embed/QEjtnmZaJio">
        </iframe>
      </p>
    </section>
  );
};
